const Table = require('./Table');
const { toInt, toString } = require('@/functions/transform');

/**
 * Collection of defined Tables in TablePlan.
 */
class TablePlan {
    constructor() {
        /**
         * @type {?number}
         */
        this.ID = null;

        /**
         * @type {string}
         */
        this.name = '';

        /**
         * @type {string}
         */
        this.status = '';

        /**
         * @type {Array<Table>}
         */
        this.tables = [];
    }

    getHydrationMap() {
        return {
            ID: {
                field: ['ID', 'tablePlanID'],
                transform: toInt,
            },
            name: toString,
            status: toString,
            tables: {
                modelCollection: Table,
            },
        };
    }
}

module.exports = TablePlan;
